export const SET_FAVORITE_EXERCISES = "SET_FAVORITE_EXERCISES";
export const SET_FAVORITE_WORKOUTS = "SET_FAVORITE_WORKOUTS";
export const SET_TO_PLAY_FAVORITE = "SET_TO_PLAY_FAVORITE";


